/** author：胡枭 */

<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <div class="flex-content">
        <WujieVue
          v-if="isMicroApp"
          width="100%"
          height="100%"
          :name="wujieName"
          :url="wujieUrl"
          :props="wujieProps"
          :before-load="wujieBeforeLoad"
          :after-unmount="wujieAfterUnmount"
          :after-mount="wujieAfterMount"
          :activated="wujieActivated"
          :deactivated="wujieDeactivated"
        />
        <keep-alive v-else :include="cachedViews">
          <router-view :key="key" />
        </keep-alive>
      </div>
    </transition>
  </section>
</template>

<script>
import wujieMixin from '@/mixins/wujie-mixin'

export default {
  name: 'AppMain',

  mixins: [wujieMixin],

  computed: {
    cachedViews() {
      return this.$store.state.router.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background: $body-background-color;
}
</style>
